export default __webpack_public_path__ + "static/Akkordeon-Five-9cb49473b61191e4a330772d0f14f1ad.woff2";